import {
  CurrentTenantState,
  REQUEST_TENANT_BRAND_NAMES,
  REQUEST_TENANT_DISTRIBUTORS,
  REQUEST_TENANT_LANGUAGES,
  REQUEST_TENANT_PRODUCT_PRIORITIES,
  REQUEST_TENANT_RELOAD,
  REQUEST_TENANT_TYPES,
  REQUEST_TENANTS,
  TenantActionTypes,
  TenantsState
} from "./types";

const initialTenantState: TenantsState = {
  list: [],
  distributors: [],
  types: [],
  brandNames: [],
  productPriorites: []
};

const initialCurrentTenantState: CurrentTenantState = {
  languages: []
};

export function tenantReducer(
  state = initialTenantState,
  action: TenantActionTypes
) {
  switch (action.type) {
    case REQUEST_TENANTS:
      return { ...state, list: action.payload };
    case REQUEST_TENANT_DISTRIBUTORS:
      return { ...state, distributors: action.payload };
    case REQUEST_TENANT_TYPES:
      return { ...state, types: action.payload };
    case REQUEST_TENANT_BRAND_NAMES:
      return { ...state, brandNames: action.payload };
    case REQUEST_TENANT_PRODUCT_PRIORITIES:
      return { ...state, productPriorites: action.payload };
    default:
      return state;
  }
}

export function currentTenantReducer(
  state = initialCurrentTenantState,
  action: TenantActionTypes
) {
  switch (action.type) {
    case REQUEST_TENANT_LANGUAGES:
      return { ...state, languages: action.payload };
    default:
      return state;
  }
}

export function reloadTenantReducer(state = false, action: TenantActionTypes) {
  switch (action.type) {
    case REQUEST_TENANT_RELOAD:
      return action.payload;
    default:
      return state;
  }
}
